import React, { useState } from 'react';
import './ContactPage.css';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    number: '',
    email: '',
    question: ''
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'number') {
      const numericValue = value.replace(/[^0-9]/g, '');
      setFormData(prev => ({ ...prev, [name]: numericValue }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');

    try {
      const payload = {
        name: formData.name,
        phone: formData.number,
        email: formData.email,
        message: formData.question,
        _subject: `Website Enquiry from ${formData.name}`,
        _replyto: formData.email,
        _captcha: 'false',
        _template: 'table',
      };

      const response = await fetch('https://formsubmit.co/ajax/commercialcarpetcleaningoxon@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
        referrerPolicy: 'origin',
      });

      const data = await response.json();
      console.log('FormSubmit response:', response.status, data);

      if (response.ok && data.success) {
        setSubmitStatus('success');
        setFormData({ name: '', number: '', email: '', question: '' });
      } else {
        console.error('FormSubmit error:', data);
        setSubmitStatus('error');
      }
    } catch (err) {
      console.error('Form submission failed:', err);
      setSubmitStatus('error');
    }
  };

  return (
    <div className="contact-page page-top">
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Get In Touch</h2>
            <p>
              Ready to discuss your carpet cleaning needs? Give us a call or send us a 
              message — we respond the same day.
            </p>
          </div>

          <div className="contact-quick">
            <a href="tel:+447887394404" className="contact-quick__item">
              <span className="contact-quick__icon">&#128222;</span>
              <span className="contact-quick__label">Call Us</span>
              <span className="contact-quick__value">07887 394404</span>
            </a>
            <a href="mailto:commercialcarpetcleaningoxon@gmail.com" className="contact-quick__item">
              <span className="contact-quick__icon">&#9993;</span>
              <span className="contact-quick__label">Email Us</span>
              <span className="contact-quick__value">commercialcarpetcleaningoxon@gmail.com</span>
            </a>
          </div>

          <div className="contact-layout">
            <div className="contact-layout__form">
              <h3>Send Us a Message</h3>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="number">Phone Number</label>
                  <input
                    type="tel"
                    id="number"
                    name="number"
                    value={formData.number}
                    onChange={handleChange}
                    placeholder="Your phone number"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your email address"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="question">How Can We Help?</label>
                  <textarea
                    id="question"
                    name="question"
                    value={formData.question}
                    onChange={handleChange}
                    placeholder="Tell us about your space and what you need..."
                    rows="5"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn--primary btn--lg"
                  style={{ width: '100%' }}
                  disabled={submitStatus === 'sending'}
                >
                  {submitStatus === 'sending' ? 'Sending...' : 'Send Your Enquiry'}
                </button>

                {submitStatus === 'success' && (
                  <p className="form-status form-status--success">
                    Thank you! Your message has been sent. We'll get back to you the same day.
                  </p>
                )}
                {submitStatus === 'error' && (
                  <p className="form-status form-status--error">
                    Something went wrong. Please try again, or call us directly on 07887 394404.
                  </p>
                )}
              </form>
            </div>

            <div className="contact-layout__area">
              <h3>Our Service Area</h3>
              <div className="contact-area-image">
                <img
                  src="/images/oxford_dreaming_spires.jpg"
                  alt="The dreaming spires of Oxford — our home city"
                />
              </div>
              <p className="contact-area-note">
                Based in Oxfordshire, we cover Oxford, Abingdon, Banbury,
                Bicester, Witney, Didcot, Thame, and surrounding areas.
                We're happy to travel further for larger commercial contracts.
              </p>
              <div className="contact-area-hours">
                <h4>We Work When You Need Us</h4>
                <p>Early mornings, evenings, overnight, and weekends — seven days a week. We fit around your business, not the other way around.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContactPage;
